import { faExclamation, faPlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { Route } from 'next';
import Link from 'next/link';
import ImageView from '../../../../components/ui/ImageView/ImageView';
import fontsStyles from '../../../../styles/modules/fonts.module.scss';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import { isVersion } from '../../../../utils/version';
import type { LotteryDrawResultLineup, PrizeConvertedGoodsItem } from '../../types';
import { prizeList2goodsList } from '../../utils';
import styles from './LotteryDrawResultMulti.module.scss';
type LotteryDrawResultMultiProps = {
  items: LotteryDrawResultLineup[];
  version?: string | null;
  cutoffId?: number | null;
  showPrizeLabel?: boolean;
  isDisplayPrizeOptionIcon?: boolean;
};

function LotteryDrawResultMulti({
  items,
  version,
  cutoffId,
  showPrizeLabel = true,
  isDisplayPrizeOptionIcon = true,
}: LotteryDrawResultMultiProps) {
  const goodsList = prizeList2goodsList(items);

  const getHref = (goods: PrizeConvertedGoodsItem): Route => {
    if (isVersion(version, '2.0')) {
      return `/account/collection/${goods.id}?cutoffId=${cutoffId ?? ''}` as Route;
    }
    return `/account/collection/${goods.id}?deliveryId=${goods.deliveryId ?? ''}` as Route;
  };
  return (
    <div className={styles.container}>
      <ul className={styles.componentStyle}>
        {goodsList.map((goods, index) => {
          const isDisplayIcon = goods.isPrizeOption && isDisplayPrizeOptionIcon;
          return (
            <li key={`${goods.id}-${goods.deliveryId ?? 'no-delivery'}-${index}`}>
              <Link className={styles.itemLink} href={getHref(goods)}>
                <div className={styles.imageWrapper}>
                  <div className={styles.itemImage}>
                    {isDisplayIcon && (
                      <span className={styles.prizeOptionIcon}>
                        <FontAwesomeIcon icon={faPlay} className={styles.triangleIcon} />
                        <FontAwesomeIcon icon={faExclamation} className={styles.exclamationIcon} />
                      </span>
                    )}
                    <ImageView src={goods.imageUrl} />
                  </div>
                  {showPrizeLabel && staging(goods)}
                </div>
                <div className={`${styles.itemName} ${utilsStyles.textBold}`}>{goods.name}</div>
              </Link>
            </li>
          );
        })}
        {/* ダミー */}
        {dummy()}
      </ul>
    </div>
  );
}

function staging(goods: PrizeConvertedGoodsItem) {
  if (goods.benefitMultiDrawCount) {
    // 特典がある場合はstagingTextは表示しない
    return (
      <div className={styles.benefitWrapper}>
        <span className={fontsStyles.montserrat}>{goods.benefitMultiDrawCount}</span>
        <small>連特典</small>
      </div>
    );
  }

  if (goods.stagingText) {
    return (
      <>
        <div className={`${styles.stagingRank} ${styles[`rank${goods.stagingRank}`]}`} />
        <div className={`${styles.stagingText} ${fontsStyles.montserrat}`}>
          {goods.stagingText}
          <small>賞</small>
        </div>
        <div className={`${styles.stagingStar} ${styles[`rank${goods.stagingRank}`]}`} />
      </>
    );
  }

  return <></>;
}

function dummy() {
  const dummy = [];
  for (let i = 0; i < 4; i++) {
    dummy.push(<li key={`dummy_${i}`} />);
  }
  return dummy;
}

export default LotteryDrawResultMulti;
